export default __webpack_public_path__ + "static/media/070_boost.vp9.91f851d7.webm";